module.exports = __webpack_public_path__ + "img/panchito-nohand.7a989739.png";